import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {$contentTemplates} from "../../$content-templates.factory";

export class ContentTemplateSelectListComponent implements IController {

  options: any;
  selectedId: any;
  ngPlaceholder: any;
  excludeIds: any;
  onChange: Function;

  public excludedMap: any;
  private contentTemplatesRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  // private queryString: any;

  constructor(private $contentTemplates: $contentTemplates, private $infiniteScroll) {
  }

  $onInit() {
    if (!this.options) {
      this.contentTemplatesRef = this.$contentTemplates();
      this.loadLimit = 20;

      this.contentTemplatesRef.$query({});
      this.infiniteScroll = this.$infiniteScroll(this.contentTemplatesRef, this.loadLimit, {getFullData: true});
    }
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }
  }

  // submitQuery(query) {
  //   this.queryString = query;
  //   if (!this.options) {
  //     this._reload();
  //   }
  // }

  // private _reload() {
  //   this.contentTemplatesRef.$query()
  //     .then(() => {
  //       this.infiniteScroll.reload();
  //     })
  //     .catch((error) => {
  //       this.$log.error('Fail to $query', error);
  //     })
  // }

  // private _getQueryPayload() {
  //   return {
  //     limit: this.loadLimit,
  //     query: this.queryString,
  //     isDemand: this.isDemand,
  //     isBusiness: this.isBusiness,
  //     isSupply: this.isSupply,
  //     branchIds: this.branchIds,
  //     depotIds: this.depotIds,
  //     type: this.type,
  //     sort: 'name,asc'
  //   };
  // }
}

angular
  .module('bringoz.admin.content-templates')
  .component('contentTemplateSelectList', {
    bindings: {
      options: '<?',
      selectedId: '<',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      onChange: '&'
    },
    template: require('./content-template-select-list.html').default,
    controller: ContentTemplateSelectListComponent
  });
